import React, { Component } from 'react';
import $ from 'jquery';
import { getMainCookie } from '../../../util/util';
import MenuBar from '../../components/MenuBar/MenuBar'
import  './css/Maintenance.css';
import './js/Maintenance'
import SideBarAdmin from '../../components/AdminConfig/SideBarAdmin';
import MaintenanceSummary from '../../components/Maintenance/MaintenanceSummary';
import SideBarToggle from '../../components/AdminConfig/Content/SideBarToggle';
import MaintenanceInformation from "../../components/Maintenance/MaintenanceInformation";
import MaintenanceTemplate from "../../components/Maintenance/MaintenanceTemplate";



class Maintenance extends Component {

    constructor() {
        super();

        this.state = {
            isMaintenanceTap: true,
            isClickMaintenanceSummary: true,
            isClickMaintenanceInformation: false,
            isAddAlertMA: false,
            isClickMaintenanceTemplate: false,
            carNumber: {}
        };

    }

    componentWillMount() {
        const cookieObj = getMainCookie();
        this.setState({
            userLevel: cookieObj.user_level,
            user_name: cookieObj.login_name,
            user_id: cookieObj.user_id,
            token: cookieObj.token
        });
    }

    componentDidMount() {
        $('#sidebar').toggleClass('active');
        $('#sidebarAdminCollapse').on('click', function () {
            $('#sidebar').toggleClass('active');

            for(let i=0;i<$('#adminSidebar>li').length;i++){
                if($('#adminSidebar>li')[i].className.indexOf('menumini')>-1)
                    $('#adminSidebar>li')[i].className="";
                else
                    $('#adminSidebar>li')[i].className="menumini";
            }

        });
        this.setListClick();
    }

    componentDidUpdate(){
        this.setListClick();

    }

    componentWillUnmount() {
        this.setState({
            isMaintenanceTap: false,
            isClickMaintenanceSummary: true,
            isClickMaintenanceInformation: false
        });
    }

    setListClick(){
        $('.list-unstyled li').click(function(e) {
            e.preventDefault()

            let that = $(this);

            that.parent().parent().parent().parent().find('li').removeClass('sub-active');
            that.addClass('sub-active');

            if(that.parent().parent().parent()[0].className.indexOf('menumini')>-1){
                that.parent().removeClass('show');
                that.parent().parent().parent().parent().parent().find('a').attr("aria-expanded","false");
                that.parent().parent().parent().find('.dropdown-toggle').attr("aria-expanded","true")

            }

        });
    }

    onClickSideBar = (sideBarName) => {
        if (sideBarName === 'maintenanceSummary') {
            this.setState({
                sideBarName,
                isClickMaintenanceSummary: true,
                isClickMaintenanceInformation: false,
                isClickMaintenanceTemplate: false
            });
        } else if (sideBarName === 'maintenanceฺInformation') {
            this.setState({
                sideBarName,
                isClickMaintenanceSummary: false,
                isClickMaintenanceInformation: true,
                isClickMaintenanceTemplate: false
            });
        } else if (sideBarName === 'maintenanceTemplate') {
            this.setState({
                sideBarName,
                isClickMaintenanceSummary: false,
                isClickMaintenanceInformation: false,
                isClickMaintenanceTemplate: true
            });
        }
    }

    render() {
        const {
            sideBarName,
            userLevel,
            user_name,
            user_id,
            token,
            isMaintenanceTap,
            isClickMaintenanceSummary,
            isClickMaintenanceInformation,
            isAddAlertMA,
            isClickMaintenanceTemplate,
            carNumber
        } = this.state;
        // console.log('carNumber Mom:', carNumber);
    return (
      <div style={{marginTop: 50}}>
         <MenuBar tab_maintenance="active"/>
          <div className="wrapper">
              <nav id="sidebar">
                  <SideBarAdmin
                      isMaintenanceTap={isMaintenanceTap}
                      onClickSideBar={this.onClickSideBar}
                      userLevel={userLevel}
                  />
              </nav>
              <div id="content">
                  <SideBarToggle/>
                  {isClickMaintenanceSummary &&
                      <MaintenanceSummary
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          // sideBarName={sideBarName}
                          onClickAddAlertMA={(data) => this.setState({
                              isClickMaintenanceSummary: false,
                              isClickMaintenanceInformation: true,
                              isAddAlertMA: true,
                              isClickMaintenanceTemplate: false,
                              carNumber: data
                          })}
                      />
                  }
                  {isClickMaintenanceInformation &&
                      <MaintenanceInformation
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          isAddAlertMA={isAddAlertMA}
                          onClickAddAlertMA={() => this.setState({
                              isClickMaintenanceSummary: true,
                              isClickMaintenanceInformation: false,
                              isAddAlertMA: false,
                              isClickMaintenanceTemplate: false
                          })}
                          carNumber={carNumber}
                      />
                  }
                  {isClickMaintenanceTemplate &&
                      <MaintenanceTemplate
                          userLevel={userLevel}
                          user_name={user_name}
                          user_id={user_id}
                          token={token}
                          isAddAlertMA={isAddAlertMA}
                          onClickAddAlertMA={() => this.setState({
                              isClickMaintenanceSummary: true,
                              isClickMaintenanceInformation: false,
                              isAddAlertMA: false,
                              isClickMaintenanceTemplate: false
                          })}
                      />
                  }
              </div>
          </div>
      </div>
    );
  }
 }

export default Maintenance;



// WEBPACK FOOTER //
// ./src/app/view/containers/Maintenance/Maintenance.js